import { LocaleCode } from '../LocaleSelector';

export const transformLocaleCodeForDisplay = (
  localeCode: LocaleCode
): string => {
  switch (localeCode) {
    // ==== START - Fallback support for Tier 3 ==== //
    // https://github.com/cultureamp/ca-languages/blob/main/LANGUAGES.md#tier-3
    case 'de-x-informal':
      return 'de';
    case 'en-360':
      return 'en';
    case 'kr':
      return 'ko';
    case 'no':
      return 'nb';
    case 'ns':
      return 'nso';
    // ==== END - Fallback support for Tier 3 ==== //
    case 'zh':
      return 'zh-HANS'; // Simplified Chinese
    case 'zh-TW':
      return 'zh-HANT'; // Traditional Chinese
    default:
      return localeCode;
  }
};
